/**
 * mapFarmshopToShareTarget — normalizes producer farm shop data into a ShareTarget.
 * Canonical data sources:
 *   - producers → name, slug, id, farm_shop_intro, farm_shop_opening_hours_text
 *   - media_assets → cover image
 *   - places → place name (optional)
 */

import type { ShopShareTarget } from '../ShareTarget';

interface FarmshopMapperInput {
  producerId: string;
  producerName: string;
  producerSlug: string;
  /** Optional cover image URL (resolved from media_assets) */
  heroImageUrl?: string | null;
  /** Short intro text from producer.farm_shop_intro */
  shopIntro?: string | null;
  /** Opening hours snippet from producer.farm_shop_opening_hours_text */
  openingHoursText?: string | null;
  /** Place/venue name if available */
  placeName?: string | null;
}

export function mapFarmshopToShareTarget(input: FarmshopMapperInput): ShopShareTarget {
  const { producerId, producerName, producerSlug, heroImageUrl, shopIntro, openingHoursText, placeName } = input;

  // Build a compact opening snippet from opening hours
  const openingSnippet = openingHoursText?.trim().slice(0, 80) || null;

  return {
    type: 'shop',
    id: producerId, // shop is identified by producer
    slug: producerSlug,
    title: `Gårdsbutiken hos ${producerName}`,
    heroImageUrl: heroImageUrl ?? null,
    producerName,
    producerSlug,
    producerId,
    openingSnippet,
    placeName: placeName ?? null,
    shopIntro: shopIntro?.trim().slice(0, 160) || null,
  };
}
